import { CheckCircle2, LayoutDashboard, ReceiptText } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '../../components/layout/page-layout'
import { Container } from '../../components/ui/container'

export default function SubscriptionSuccessPage() {
  const { t } = useTranslation()

  return (
    <PageLayout>
      <Container>
        <div className='mx-auto max-w-2xl py-10'>
          <div className='rounded-2xl border border-emerald-200 bg-white p-8 shadow-sm'>
            <div className='flex items-center gap-3 text-emerald-700'>
              <CheckCircle2 className='h-8 w-8' />
              <h1 className='text-2xl font-semibold text-gray-900'>
                {t('subscription.successTitle')}
              </h1>
            </div>

            <p className='mt-4 text-sm leading-6 text-gray-600'>{t('subscription.successMessage')}</p>

            <div className='mt-6 rounded-xl border border-emerald-100 bg-emerald-50 px-4 py-3 text-sm text-emerald-800'>
              {t('subscription.successHint')}
            </div>

            <div className='mt-8 flex flex-wrap gap-3'>
              <Link
                to='/subscription'
                className='inline-flex items-center gap-2 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700'
              >
                <LayoutDashboard className='h-4 w-4' />
                {t('subscription.backToSubscription')}
              </Link>
              <Link
                to='/subscription'
                className='inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50'
              >
                <ReceiptText className='h-4 w-4' />
                {t('subscription.checkStatus')}
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </PageLayout>
  )
}
